'use strict';

var React = require('react');

var SvgViewportTallMajor = function SvgViewportTallMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9v-2.44l-.72.72a.75.75 0 1 1-1.06-1.06l2-2a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-.72-.72v2.44a.75.75 0 0 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 16a2.75 2.75 0 0 1-2.75-2.75v-6.5a2.75 2.75 0 0 1 2.75-2.75h.875a.75.75 0 0 1 0 1.5h-.875c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h.875a.75.75 0 0 1 0 1.5h-.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.625 15.25a.75.75 0 0 1 .75-.75h.875c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25h-.875a.75.75 0 0 1 0-1.5h.875a2.75 2.75 0 0 1 2.75 2.75v6.5a2.75 2.75 0 0 1-2.75 2.75h-.875a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 13.44v-2.44a.75.75 0 0 1 1.5 0v2.44l.72-.72a.75.75 0 0 1 1.06 1.06l-2 2.001a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72Z"
  }));
};
SvgViewportTallMajor.displayName = "ViewportTallMajor";

exports.SvgViewportTallMajor = SvgViewportTallMajor;
